import { render, staticRenderFns } from "./UserLockModal.vue?vue&type=template&id=642210fe&scoped=true&"
import script from "./UserLockModal.vue?vue&type=script&lang=js&"
export * from "./UserLockModal.vue?vue&type=script&lang=js&"
import style0 from "./UserLockModal.vue?vue&type=style&index=0&id=642210fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642210fe",
  null
  
)

export default component.exports